<template>
	<div class="Reset account-pages my-5 pt-sm-5">
		<div class="container">
			<div
				class="row justify-content-center text-fix"
				style="opacity: 0.92"
				id="login-form"
			>
				<div class="col-md-8 col-lg-6 col-xl-5">
					<div class="card overflow-hidden">
						<div
							class="text-white"
							style="
								font-family: HeaderCustomFont;
								background-color: #526635 !important;
							"
						>
							<div class="row">
								<div class="col-12">
									<div class="p-4">
										<h6 class="text-uppercase text-dark font-size-15">
											Speke Holidays Uganda
										</h6>
										<h3>Speke Management System</h3>
										<p class="text-dark font-size-18">Forgot Password:</p>
									</div>
								</div>
							</div>
						</div>
						<div class="card-body pt-0">
							<div class="auth-logo">
								<a href="/" class="auth-logo-dark">
									<div class="avatar-md profile-user-wid mb-1">
										<span class="avatar-title rounded-circle bg-light">
											<img
												src="images/logo-sm.png"
												alt=""
												class="rounded-circle"
												width="34"
											/>
										</span>
									</div>
								</a>

								<!-- <a href="/" class="auth-logo-dark"> </a> -->
							</div>
							<div class="p-2">
								<form
									class="form-horizontal text-dark font-size-14"
									@submit.prevent
								>
									<div class="mb-5">
										<label for="username" class="form-label">Enter Email</label>
										<input
											type="text"
											class="form-control text-dark"
											id="UserEMailAddress"
											v-model="resetPass.UserEMailAddress"
											placeholder="Enter username"
											:class="{
												'is-invalid': resetPass.errors.has('UserEMailAddress'),
											}"
										/>
										<div
											class="invalid-feedback is-invalid"
											:form="resetPass"
											field="LoginID"
											v-html="resetPass.errors.get('UserEMailAddress')"
										/>
									</div>

									<div
										class="modal-footer justify-content-start"
										style="font-family: HeaderCustomFont"
									>
										<div
											class="d-grid font-size-15"
											style="font-family: HeaderCustomFont; margin-top: 50px"
										>
											<button
												type="button"
												@click="resetPassword()"
												style="background-color: #526635 !important"
												class="btn text-white border-0"
											>
												Reset Password
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- end account-pages -->
</template>



<script >
// Layout Components
// import ResetLayout from "../components/ResetLayout.vue";

// Form Components
import { Form } from "vform";
import axios from "axios";
axios.defaults.withCredentials = true;

import cookie from "js-cookie";
import config from "../config/settings.js";

// Plugins:

export default {
	name: "Forgot",

	data() {
		return {
			api: config.API_URL,
			message: "",
			user: [],
			http_code: "",
			errors: [],
			resetPass: new Form({
				UserEMailAddress: "",
			}),
		};
	},
	methods: {
		cacheUser() {
			this.$router.push("/dash");
		},
		getCookie() {
			let token = cookie.get("XSRF-TOKEN");
			if (token) {
				return new Promise((resolve) => {
					resolve(token);
				});
			} else {
				return axios.get(this.api + "/csrf-cookie");
			}
		},
		resetPassword() {
			this.resetPass
				.post(this.api + "/forgot")
				.then((response) => {
					this.message = response.data.message;

					this.$swal({
						text: this.message,
						icon: "success",
						position: "top-end",
						background: "#52BE80",
					});

					// this.$Progress.finish();
					this.resetPass.reset();
				})
				.catch((error) => {
					this.message = error.response.data.message;
					this.http_code = error.response.status;
					if (this.http_code == 400) {
						this.$swal({
							text: "Error " + this.http_code + ": " + this.message,
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
						});
					} else if (this.http_code == 422) {
						this.$swal({
							text: "Error " + this.http_code + ": Invalid Information",
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
							timer: 7500,
						});
					} else {
						this.$swal({
							text: "Error " + this.http_code + ": " + this.message,
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
							timer: 7500,
						});
					}
				});
		},
	},
	created() {
		// this.$emit("update:layout", ResetLayout);
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
};
</script>

<style>
/*** EDWIN: API call with access token
axios.get('/api/endpoint', {
headers: {
	'Authorization': 'Bearer ' + yourToken
}
})
.then(response => {
	// handle success
})
.catch(error => {
	// handle error
})		 
***/
</style>
